import { Parameter, ClaimsFileType } from '@ecosure-suite/shared/utils-helpers';

export interface ClaimDocument {
  id: number;
  type: ClaimsFileType;
  owner: Parameter;
  ext?: string;
  format?: string;
  uri?: string;
  dateCreated?: Date;
}

export class ClaimDocumentForm {
  owner: Parameter;
  document?: ClaimDocument;
  type: ClaimsFileType;
  file: File;
}
